import { deserify, HelpSupport } from '@geneo2-web/shared-ui';
import { useNavigate } from 'react-router-dom';
import { FAQ } from '../../../routeHandling/RoutesNomenclature';
import { useAppSelector } from '../../../reduxStore/reduxHooks';

interface IProps {}

export const HelpAndSupport = (props: IProps) => {
  const navigate = useNavigate();
  const { user_info } = deserify(useAppSelector((state) => state.auth));

  return (
    <HelpSupport
      onFaqClick={() => navigate(FAQ)}
      schoolId={user_info?.schoolDetails[0]?.schoolId}
    />
  );
};
